import React from 'react'
import axios from 'axios';
import { useEffect, useState } from 'react';

import { MapContainer, TileLayer, Marker, Popup, useMap, Polygon, LayersControl ,WMSTileLayer,WM} from 'react-leaflet'

import 'leaflet/dist/leaflet.css'




function TheMap() {
  const zoom = 5
const center = [15.0, 30.2176]    
const [lastDate, setLastDate] = useState('');
const [isLoaded, setIsLoaded] = useState(false);
  const getCap = async () => {
      const res = await fetch("https://data.apps.fao.org/map/wmts/wmts?tilematrix=1&layer=fao-gismgr%2FWAPOR-3%2Fmapsets%2FL1-PCP-E&style=PCP-E&tilerow=0&tilecol=0&tilematrixset=EPSG%3A4326&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetCapabilities").then((res) => res.text());
      return res.split("<ows:Identifier>PCP-E</ows:Identifier><ows:Title>PCP-E</ows:Title></Style><TileMatrixSetLink><TileMatrixSet>EPSG:4326</TileMatrixSet></TileMatrixSetLink><Dimension><ows:Title>DAY</ows:Title><ows:Default>2018-01-01</ows:Default><ows:UOM>ISO8601</ows:UOM><ows:Identifier>time</ows:Identifier><Value>")[1].split('</Value>')[0].split(',').reverse()[0];
    }
  function FlyMapTo(props) {
    const map = useMap();
   

    useEffect(() => {
      map.flyTo(props.center, props.zoom);
     
    });
  
    return null;
  }
  const polOptions = { color: 'green' ,
  fillColor: 'green',
  fillOpacity: 0.00}
  var sudan_polygon = [ [ 35.622176422000052, 23.142564063000066 ], [ 35.926238088000048, 22.692192940000041 ], [ 36.188930464000066, 22.668874315000039 ], [ 36.896106339000028, 22.06163569000006 ], [ 36.94663033900008, 21.478506939000056 ], [ 37.32281755300005, 21.065492027000062 ], [ 37.097478371000079, 21.189032397000062 ], [ 37.40945559000005, 18.873332062000031 ], [ 38.582364469000026, 18.016185859000075 ], [ 38.265521217000071, 17.56219186800007 ], [ 37.511621217000027, 17.333791868000048 ], [ 37.394621217000065, 17.052991868000049 ], [ 37.00323611500005, 17.073266210000043 ], [ 36.963907714000072, 16.287786098000026 ], [ 36.432812242000068, 15.166584133000072 ], [ 36.560351242000024, 14.256678132000047 ], [ 36.168894089000048, 12.692160594000029 ], [ 35.699821217000078, 12.666091868000024 ], [ 35.095321217000048, 11.816091868000058 ], [ 34.976783741000077, 10.883770129000027 ], [ 34.783621217000075, 10.701491868000062 ], [ 34.602721217000067, 10.903291868000053 ], [ 34.300021217000051, 10.574891868000066 ], [ 34.348121217000028, 10.170391868000024 ], [ 34.112721217000058, 9.498591868000062 ], [ 33.887721217000035, 9.546191868000051 ], [ 33.966221217000054, 10.153891868000073 ], [ 33.482721217000062, 10.657891868000036 ], [ 33.219021217000034, 10.734991868000066 ], [ 33.140521217000071, 11.62809186800007 ], [ 33.29583408600007, 12.215780844000051 ], [ 32.737074208000024, 12.236845169000048 ], [ 32.741419710000059, 11.946901844000024 ], [ 32.106579460000034, 11.94499821900007 ], [ 32.384500585000069, 11.696582469000077 ], [ 32.459900994000066, 10.97638783900004 ], [ 32.192846582000072, 10.714150209000024 ], [ 32.228538496000056, 10.509516563000034 ], [ 31.933485331000043, 10.49048087500006 ], [ 31.288745584000026, 9.761543467000024 ], [ 30.827326834000075, 9.71890946700006 ], [ 29.94226608300005, 10.287722842000051 ], [ 29.539039707000029, 10.081831842000042 ], [ 29.538087957000073, 9.750134967000065 ], [ 29.078376082000034, 9.750134967000065 ], [ 28.768585337000047, 9.348417829000027 ], [ 28.038866682000048, 9.343225190000055 ], [ 27.898443335000024, 9.610853281000061 ], [ 26.662191059000065, 9.486818260000064 ], [ 26.324479200000042, 9.605355430000031 ], [ 25.813225454000076, 10.439864967000062 ], [ 25.098403078000047, 10.313130342000022 ], [ 25.032729953000057, 10.033781592000025 ], [ 24.720068828000024, 9.744439217000036 ], [ 24.526856578000036, 8.845002841000053 ], [ 24.383613078000053, 8.789799466000034 ], [ 24.244176578000065, 8.647983466000028 ], [ 24.22364830500004, 8.64132883000002 ], [ 23.527282684000056, 8.750157502000036 ], [ 23.613401220000071, 8.980031695000037 ], [ 23.442127493000044, 9.015731432000052 ], [ 23.683397198000023, 9.430692747000023 ], [ 23.672038892000046, 9.89319967800003 ], [ 22.878250641000022, 10.912084804000074 ], [ 22.941544391000036, 11.426048430000037 ], [ 22.560354766000046, 11.631157930000029 ], [ 22.636973391000026, 12.060888680000062 ], [ 22.476597765000065, 12.025196680000022 ], [ 22.363752900000065, 12.44308809000006 ], [ 22.463609172000076, 12.63293395200003 ], [ 22.197635816000059, 12.752919955000038 ], [ 21.949132869000039, 12.621190077000051 ], [ 21.813680015000045, 12.802804431000027 ], [ 22.300862751000068, 13.35972416900006 ], [ 22.072392588000071, 13.776773319000029 ], [ 22.532562975000076, 14.110949537000067 ], [ 22.384143857000026, 14.518689331000076 ], [ 22.713461227000039, 14.695721235000065 ], [ 22.673962176000032, 14.859428153000067 ], [ 22.934246800000039, 15.104256150000026 ], [ 22.927046800000028, 15.553856150000058 ], [ 23.12030874900006, 15.716745581000055 ], [ 23.998846800000024, 15.713856150000026 ], [ 24.000148570000079, 20.006587348000039 ], [ 25.002913548000038, 20.00704743700004 ], [ 24.998821217000057, 22.000391868000065 ], [ 31.305321217000028, 21.999891868000077 ], [ 31.473521217000041, 22.225391868000031 ], [ 31.407921217000023, 21.99969186800007 ], [ 33.164137739000068, 21.998945139000057 ], [ 33.729768740000054, 21.73944663900005 ], [ 34.003406740000059, 21.76942813900007 ], [ 34.150457240000037, 22.202489639000078 ], [ 34.686312241000053, 22.296716639000067 ], [ 34.944721241000025, 22.858745140000053 ], [ 35.198122741000077, 22.784515640000052 ], [ 35.622176422000052, 23.142564063000066 ] ];
  sudan_polygon = sudan_polygon.map(function(arr) { return [arr[1], arr[0]] });
  const data =[
    {"name":"Wind",
    "slug":"wind_new"},
    {"name":"Temperature",
    "slug":"temp_new"},
    {"name":"Clouds",
    "slug":"clouds_new"},
    {"name":"Precipitation",
    "slug":"precipitation_new"}

    ]
    //fetch cap and get the last date
   if (!isLoaded) {
      const ld =  getCap().then((res) => {
        setLastDate(res) ;
       
      setIsLoaded(true);
      });
     
    }
  




  return (
    <div className="map bg-[#4A91FF] h-[25rem]  w-full">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={true}>
        <LayersControl >
          <LayersControl.BaseLayer checked name="Open Street Map">
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="AETI - Actual evapotranspiration and interception (Global - Annual - 300m) - WaPOR v3">
            <TileLayer
              attribution='&copy;WAPOR'
              srs = "EPSG:4326"
              url='https://data.apps.fao.org/map/wmts/wmts?tilematrix={z}&layer=fao-gismgr%2FWAPOR-3%2Fmapsets%2FL1-AETI-A&style=AETI-A&tilerow={y}&tilecol={x}&tilematrixset=EPSG%3A3857&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetTile&wmts_cache_busting_retry_count=2'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="NPP - Net primary production (National - Dekadal - 100m) - WaPOR v3">
            <TileLayer
              attribution='&copy;WAPOR'
              srs = "EPSG:4326"
              url='https://data.apps.fao.org/map/wmts/wmts?tilematrix={z}&layer=fao-gismgr%2FWAPOR-3%2Fmapsets%2FL2-NPP-D&style=AETI-A&tilerow={y}&tilecol={x}&tilematrixset=EPSG%3A3857&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetTile&wmts_cache_busting_retry_count=2'
            />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="GBWP - Gross biomass water productivity (National - Annual - 100m) - WaPOR v3">
            <TileLayer
              attribution='&copy;WAPOR'
              srs = "EPSG:4326"
              url='https://data.apps.fao.org/map/wmts/wmts?tilematrix={z}&layer=fao-gismgr%2FWAPOR-3%2Fmapsets%2FL2-GBWP-A&style=AETI-A&tilerow={y}&tilecol={x}&tilematrixset=EPSG%3A3857&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetTile&wmts_cache_busting_retry_count=2'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer
            name="MODIS_Aqua_L3_EVI_16Day"
          >
            <WMSTileLayer
              layers={"MODIS_Aqua_L3_EVI_16Day"}
              url={`https://data.apps.fao.org/wapor/proxy/https://gibs.earthdata.nasa.gov/wms/epsg3857/best/?`}
              attribution="WAPOR"
            />
          </LayersControl.BaseLayer>

     

          <LayersControl.BaseLayer name={`Daily Percipitation - ${lastDate}`} >
            <TileLayer
             url={`https://data.apps.fao.org/map/wmts/wmts?tilematrix={z}&layer=fao-gismgr%2FWAPOR-3%2Fmapsets%2FL1-PCP-E&style=PCP-E&tilerow={y}&tilecol={x}&tilematrixset=EPSG%3A3857&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetTile&wmts_cache_busting_retry_count=2&dim_time=${lastDate}`}
              attribution="&copy;WAPOR" 
            />

          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Gross Biomass Water Productivity (Gezira, Sudan - Seasonal) 2013">
            <TileLayer
            attribution='&copy;WAPOR'
            url='https://data.apps.fao.org/map/wmts/wmts?tilematrix={z}&layer=fao-gismgr%2FWAPOR-3%2Fmosaicsets%2FL3-GBWP-A.GEZ&style=BWP-A&tilerow={y}&tilecol={x}&tilematrixset=EPSG%3A3857&format=image%2Fpng&service=WMTS&version=1.0.0&request=GetTile&dim_time=2023-01-01'
            />
          </LayersControl.BaseLayer>
         

          

        </LayersControl>
        <Polygon pathOptions={polOptions} positions={sudan_polygon} />
        <FlyMapTo center={center} zoom={zoom} />
      </MapContainer>
    </div>
  );
}

export default TheMap